































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { News } from "@/data/news/news";

@Component({
  components: {
  }
})
export default class NewsView extends Vue {
    @Prop()
  private news!: News;

  @Prop({default : false})
  private isMobile! : boolean;

  get formatedDate(){
      let date = new Date(this.news.date);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + "年" + month + "月" + day + "日"
  }

  //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get fontColorStyle(){
        return {
            "color" : this.userConfigColors.buttonColorCode
        }
    }
}
